import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { WARNING_BEFORE_MINUTES } from "@/config/session";

interface Props {
  open: boolean;
  onStay: () => void;
  onLogout: () => void;
}

export function IdleWarningDialog({ open, onStay, onLogout }: Props) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Session Expiring</AlertDialogTitle>
          <AlertDialogDescription>
            Your session is about to expire due to inactivity. You will be
            logged out in {WARNING_BEFORE_MINUTES}{" "}
            {WARNING_BEFORE_MINUTES as number === 1 ? "minute" : "minutes"}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onLogout}>Log Out</AlertDialogCancel>
          <AlertDialogAction onClick={onStay}>Stay Signed In</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
